import { Forward } from './forward.model'
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'

export interface State extends EntityState<Forward> {
  isLoaded: boolean
}

export const adapter: EntityAdapter<Forward> = createEntityAdapter<Forward>({
  sortComparer: false,
})

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
})
